const discoverES = {
	loading: "Cargando…",
	toolbar: {
		filters: "⚙︎ Filtros",
		sortBy: "Ordenar por:",
		showMap: "Mostrar mapa",
		recommended: "Recomendado",
	},
	sort: {
		distance: "Distancia",
		highestRated: "Mejor valoradas",
		lowestRated: "Peor valoradas",
		recommended: "Recomendado"
	},
	title: "Tiendas",
	subtitle: "¿Qué afecta los resultados de búsqueda?",
	reviews: "reseñas",
	shop: {
		untitled: "Tienda sin nombre",
	},
	services: {
		book: "Reservar",
		more: (count) => `+${count} servicios más`,
	},
	empty: "No se encontraron tiendas.",
};

export default discoverES;
